module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Black.71aa9b9d.ttf";